import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addCareHomeGroupFailure,
  //
  addCareHomeGroupSuccess,
  deleteCareHomeGroupFailure,
  //
  deleteCareHomeGroupSuccess,
  editCareHomeGroupFailure,
  //
  editCareHomeGroupSuccess,
  fetchCareHomeGroups as fetchCareHomeGroupsAction,
  fetchCareHomeGroupsFailure,
  fetchCareHomeGroupsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  searchCareHomeFailure,
  //
  searchCareHomeSuccess,
} from "./actions";
import {
  ADD_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP,
  FETCH_CARE_HOME_GROUPS,
  GET_VIEW_DATA,
  SEARCH_CARE_HOME_GROUP,
} from "./constants";

export function* fetchCareHomeGroupsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company?${query}`);
    yield put(fetchCareHomeGroupsSuccess(data));
  } catch (e) {
    yield put(fetchCareHomeGroupsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching company!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching company!"));
  }
}

export function* addCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/company/add`, payload.data);
    if (data) {
      yield put(successAlert("Company added successfully!"));
      yield put(addCareHomeGroupSuccess());
      if (payload?.history) {
        payload.history.push("/d/company");
      }
    }
  } catch (e) {
    yield put(addCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Company updated successfully!"));
      yield put(editCareHomeGroupSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/company/${payload}`);
    if (data) {
      yield put(successAlert("Company deleted successfully!"));
      yield put(deleteCareHomeGroupSuccess());
      yield put(fetchCareHomeGroupsAction());
    }
  } catch (e) {
    yield put(deleteCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchCareHomeSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company?${query}`);
    yield put(searchCareHomeSuccess(data));
  } catch (e) {
    yield put(searchCareHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching company!"));
  }
}

export function* fetchCareHomeGroupsFlow() {
  yield takeEvery(FETCH_CARE_HOME_GROUPS, fetchCareHomeGroupsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addCareHomeGroupFlow() {
  yield takeEvery(ADD_CARE_HOME_GROUP, addCareHomeGroupSaga);
}
export function* editCareHomeGroupFlow() {
  yield takeEvery(EDIT_CARE_HOME_GROUP, editCareHomeGroupSaga);
}
export function* deleteCareHomeGroupFlow() {
  yield takeEvery(DELETE_CARE_HOME_GROUP, deleteCareHomeGroupSaga);
}
export function* searchCareHomeFlow() {
  yield takeEvery(SEARCH_CARE_HOME_GROUP, searchCareHomeSaga);
}
export default function* CareHomeGroupsSaga() {
  yield all([
    fetchCareHomeGroupsFlow(),
    addCareHomeGroupFlow(),
    editCareHomeGroupFlow(),
    deleteCareHomeGroupFlow(),
    getViewDataFlow(),
    searchCareHomeFlow(),
  ]);
}
